export const locale = {
    lang: 'en',
    data: {
        NOTIFICATIONS: {
            TITLES: {
                NO_NOTIFICATIONS: 'You have no notifications...',
                NOTIFICATIONS: 'Notifications',
                MARK_ALL_AS_READ: 'Mark all as Read',
                ONLY_SHOW_UNREAD: 'Only show unread',
                ALL: 'All',
                MESSAGES: 'Messages',
                APPOINTMENTS: 'Appointments',
                LISTINGS: 'Listings',
                TODAY: 'Today',
                YESTERDAY: 'Yesterday',
                OLDER: 'Older',
            }
        }
    }
};